import AddedProperties from '../AddedProperties';
import ClosedLeads from '../ClosedLeads';
import ConcretedOperations from '../ConcretedOperations';
import ConversionRate from '../ConversionRate';
import ConversionTime from '../ConversionTime';
import DoneVisits from '../DoneVisits';
import DoneVisitsEvolution from '../DoneVisitsEvolution';
import DoneEvents from '../DoneEvents';
import AgentsPerformance from '../AgentsPerformance';
import InquiriesReceived from '../InquiriesReceived';
import LeastConsultedDevelopments from '../LeastConsultedDevelopments';
import LeastConsultedProperties from '../LeastConsultedProperties';
import MostConsultedDevelopments from '../MostConsultedDevelopments';
import MostConsultedProperties from '../MostConsultedProperties';
import NewContacts from '../NewContacts';
import ProductionRate from '../ProductionRate';
import ReservationsCreated from '../ReservationsCreated';
import ResponseTime from '../ResponseTime';
import ResponseTimeEvolution from '../ResponseTimeEvolution';
import ConcretedOperationsEvolution from '../ConcretedOperationsEvolution';
import ConcretedOperationsSource from '../ConcretedOperationsSource';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export const componentsMap = {
  mini_cards: null,
  without_label: {
    InquiriesReceived,
    NewContacts,
  },
  SearchTrends: {
    MostInquiredProperties: MostConsultedProperties,
    LeastInquiredProperties: LeastConsultedProperties,
    MostInquiredDevelopments: MostConsultedDevelopments,
    LeastInquiredDevelopments: LeastConsultedDevelopments,
  },
  ContactManagement: {
    ResponseTime,
    ResponseTimeEvolution,
    VisitsMade: DoneVisits,
    VisitsMadeEvolution: DoneVisitsEvolution,
    EventsMade: DoneEvents,
    ReservationsCreated,
    ClosedLeads,
    ConversionRate,
    ConversionTime,
    AgentsPerformance,
  },
  PropertyProduction: {
    ProductionRate,
    AddedProperties,
  },
  ConcretedProduction: {
    ConcretedOperations,
    ConcretedOperationsSource,
    ConcretedOperationsEvolution,
  },
};

export const titlesMap = {
  mini_cards: null,
  without_label: null,
  SearchTrends: Trans(translations, 'SearchTrends'),
  ContactManagement: Trans(translations, 'ContactManagement'),
  PropertyProduction: Trans(translations, 'PropertyProduction'),
  ConcretedProduction: Trans(translations, 'ConcretedProduction'),
};
